<template>
  <div>
    <Table border :columns="columns" :data="data">
      <template slot-scope="{ row }" slot="image">
        <a v-if="row.license" href="javascript:void(0)" @click="show(row.image)">点击查看</a>
        <a href="javascript:void(0)" disabled>点击查看</a>
      </template>
      <template slot-scope="{ row }" slot="operator">
        <ButtonGroup>
          <Button type="primary" @click="edit(row.id)" size="small">编辑</Button>
          <Button v-if="row.status == 0" type="primary" @click="pass(row.id)" size="small">通过</Button>
          <Button v-if="row.status == 0" @click="refuse(row.id)" size="small">拒绝</Button>
          <Button type="error" @click="remove(row.id)" size="small">删除</Button>
        </ButtonGroup>
      </template>
    </Table>
    <div class="pagination-container">
      <Page :total="paginator.total" :page-size="paginator.size" @on-change="changePage" :current.sync="paginator.page" />
    </div>

    <Modal v-model="showImage" :footer-hide="true" width="1024">
      <img :src="shownImageSrc" alt="">
    </Modal>
  </div>
</template>

<script>
import api from '@/api';

const columns = [
  {title: '时间', key: 'createdAt', width: 120},
  {title: '公司名称', key: 'name'},
  {title: '公司地址', key: 'address'},
  {title: '状态', key: 'statusEnum', width: 80},
  {title: '营业执照', key: 'license', width: 120, slot: 'image'},
  {title: '操作', slot: 'operator', width: 240}
];

export default {
  data() {
    return {
      columns,
      data: [],
      paginator: {},
      showImage: false,
      shownImageSrc: ''
    }
  },
  methods: {
    edit(id) {
      this.$router.push({name: 'index.edit', params: {id}})
    },
    show(img) {
      alert(img),
      this.shownImageSrc = img;
      this.showImage = true;
    },
    init() {
      api.get(api.url('company'), this.pageParams()).then(res => {
        this.data = res.items;
        this.paginator = res.paginator;
      }).catch(err => {
        this.$Message.error(err);
      })
    },
    pass(id) {
      // eslint-disable-next-line
      api.put(api.url('companyPass', id)).then(_ => {
        this.$Message.success('审核通过');
        this.init();
      }).catch(err => {
        this.$Message.error(err)
      });
    },
    refuse(id) {
      // eslint-disable-next-line
      api.put(api.url('companyRefuse', id)).then(_ => {
        this.$Message.success('已拒绝');
        this.init();
      }).catch(err => {
        this.$Message.error(err)
      });
    },
    remove(id) {
      // eslint-disable-next-line
      api.delete(api.url('companyRemove', id)).then(_ => {
        this.$Message.success('已删除');
        this.init();
      }).catch(err => {
        this.$Message.error(err)
      })
    },
    pageParams() {
      return {
        page: this.$route.query.page || 1,
        size: 15
      }
    },
    changePage(ev) {
      this.$router.push({query: {page: ev}})
    }
  },
  mounted() {
    this.init();
  },
  watch: {
    '$route'() {
      this.init();
    }
  }
}
</script>

<style>
  .ivu-modal-body { display: flex; align-items: center; justify-content: center; }
  .pagination-container { margin: 24px 0; float: right; }
</style>
